import { render, staticRenderFns } from "./my-custom-loader.vue?vue&type=template&id=04ab1e68&scoped=true"
import script from "./my-custom-loader.vue?vue&type=script&lang=js"
export * from "./my-custom-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ab1e68",
  null
  
)

export default component.exports